module.exports = __webpack_public_path__ + "static/img/01_郵務管理.9ac6c0e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/button/01_郵務管理.png
// module id = T2ws
// module chunks = 1